import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { SET_EQUIPMENT_GROUPS_LIST, SET_EQUIPMENT_GROUPS_LOADING } from "./types";


export const getEquipmentGroups = () => async (dispatch) => {
  dispatch({ type: SET_EQUIPMENT_GROUPS_LOADING, payload: true });
  try {
    const { data } = await api.get('/equipment_groups');
    dispatch({ type: SET_EQUIPMENT_GROUPS_LIST, payload: data.data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_EQUIPMENT_GROUPS_LOADING, payload: false });
  }
}

export const createEquipmentGroup = (reqData, closeModal) => async (dispatch) => {
  try {
    await api.post(`/equipment_groups`, reqData);
    createNotification('success', 'Группа добавлена');
    await dispatch(getEquipmentGroups());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.detail || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  }
}

export const updateEquipmentGroup = (id, reqData, closeModal) => async (dispatch) => {
  try {
    await api.put(`/equipment_groups/${id}`, reqData);
    createNotification('success', 'Изменения сохранены');
    await dispatch(getEquipmentGroups());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.detail || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  }
}

export const deleteEquipmentGroup = (id) => async (dispatch) => {
  try {
    await api.delete(`/equipment_groups/${id}`);
    createNotification('success', 'Группа удалена');
    await dispatch(getEquipmentGroups());
  } catch (error) {
    const errorMessage = error.response?.data?.detail || 'Ошибка удаления';
    createNotification('error', errorMessage);
  }
}
